import { Box } from '@mui/material';

const Image = (props: any) => <Box component="img" {...props} />;

export default Image;
